import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LogtoProvider } from '@logto/react';
import './App.css';
import CookieBanner from './components/CookieBanner';
import { AuthProvider } from './contexts/AuthContext';
import { logtoConfig } from './logto';
import { luxotticaRoutes, luxotticaAuthRoutes } from './routes';

const activeRoutes = [...luxotticaRoutes, ...luxotticaAuthRoutes];

function App() {
  return (
    // LogtoProvider owns the tokens; AuthProvider adapts them to the
    // useAuth() shape the rest of the app already speaks.
    <LogtoProvider config={logtoConfig}>
      <Router>
        <AuthProvider>
          <div className="App relative">
            <main>
              <Routes>
                {activeRoutes.map((route, index) => (
                  <Route
                    key={`luxottica-${index}`}
                    path={route.path}
                    element={route.element}
                  />
                ))}
              </Routes>
            </main>
            <CookieBanner />
          </div>
        </AuthProvider>
      </Router>
    </LogtoProvider>
  );
}

export default App;